import React from 'react';
import { Github, Linkedin, Mail, Globe } from 'lucide-react';
import { profileData } from '../mockData';

const Footer = () => {
  return (
    <footer className="bg-black/50 border-t border-gray-800 py-12 px-8 md:px-12 mt-20">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-white text-lg font-semibold mb-4">Contact</h3>
            <div className="space-y-2">
              <a
                href={`mailto:${profileData.contact.email}`}
                className="flex items-center space-x-2 text-gray-400 hover:text-white transition"
              >
                <Mail size={18} />
                <span className="text-sm">{profileData.contact.email}</span>
              </a>
              <a
                href={`https://${profileData.contact.linkedin}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-gray-400 hover:text-white transition"
              >
                <Linkedin size={18} />
                <span className="text-sm">LinkedIn Profile</span>
              </a>
              <a
                href={`https://${profileData.contact.portfolio}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-gray-400 hover:text-white transition"
              >
                <Globe size={18} />
                <span className="text-sm">Portfolio Website</span>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-white text-lg font-semibold mb-4">Quick Links</h3>
            <div className="space-y-2">
              <a href="#home" className="block text-gray-400 hover:text-white transition text-sm">
                Home
              </a>
              <a href="#experience" className="block text-gray-400 hover:text-white transition text-sm">
                Experience
              </a>
              <a href="#skills" className="block text-gray-400 hover:text-white transition text-sm">
                Skills
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-white text-lg font-semibold mb-4">About</h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              Cloud & DevOps Engineer with 9+ years of experience in AWS, GCP, and Azure. 
              Passionate about automation, infrastructure as code, and building scalable systems.
            </p>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 text-center">
          <p className="text-gray-500 text-sm">
            © 2025 {profileData.name}. Built with Netflix-inspired design.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;